export type ChargingPointStation = {
  id: number
  name: string
}

/**
 * Uma faixa de um dia com o preço já resolvido pelo backend. Sem sobreposição: as faixas
 * cobrem o dia inteiro em sequência, e o `rate` é o que vai ser cobrado ali.
 */
export type TariffTimelineSegment = {
  start: string
  end: string
  rate: string
  label: string
  rule_id: number | null
  /** `fallback` = nenhuma faixa cobre esse horário; vale o preço do conector. */
  source: 'rule' | 'fallback'
}

export type TariffWeekDay = {
  date: string
  weekday: number
  is_today: boolean
  holiday?: string | null
  segments: TariffTimelineSegment[]
}

export type ChargingPoint = {
  id: number
  status: ChargingPointStatus
  title: string
  display_title: string | null
  description: string
  station: ChargingPointStation
  power: number
  rate_per_kwh: number
  activation_fee: number
  current_rate_per_kwh: number
  current_activation_fee: number
  current_idle_rate: number
  idle_grace_period_minutes: number
  tariff_plan?: { timezone: string } | null
  idle_timeline: TariffTimelineSegment[]
  is_free: boolean
  tariff_timeline: TariffTimelineSegment[]
  tariff_week_timeline: TariffWeekDay[]
  idle_rate: number
  charging_connectors: ChargingConnector[]
  connector_notifications: boolean
  created_at: string
  updated_at: string
  under_maintenance: boolean
}

export enum ChargingPointStatus {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  MAINTENANCE = 'MAINTENANCE',
  CHARGING = 'CHARGING',
  PREPARING = 'PREPARING',
  SUSPENDED_EV = 'SUSPENDED_EV',
  SUSPENDED_EVSE = 'SUSPENDED_EVSE',
  FINISHING = 'FINISHING',
  RESERVED = 'RESERVED',
  FAULTED = 'FAULTED',
}

export type ChargingPointStatusBucket = 'AVAILABLE' | 'OCCUPIED' | 'MAINTENANCE' | 'FAULTED' | 'UNAVAILABLE'

export type ChargingConnector = {
  id: number
  connector_type: string
  description: string
  created_at: string
  updated_at: string
}
